export enum StylesStepsEnum {
  PRODUCT_LINE = '1',
  SPECIFICATIONS = '2',
  DOOR_BUILDER = '3',
  STYLE_OVERVIEW = '4',
  ADJUSTMENTS = '5',
}
